import { OnInit, Component, ViewEncapsulation } from "@angular/core";
import { MatDialog as MatDialog, MatDialogRef as MatDialogRef } from "@angular/material/dialog";
import { LoaderService } from "../services/loader.service";

@Component({
    selector: 'loader-component',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class LoaderComponent implements OnInit {
    public loading$;
    constructor(public dialog: MatDialog, private ls:LoaderService){

    }

    ngOnInit(): void {
        this.loading$ = this.ls.isLoading;        
    }

}